<template>
  <div class="w-100 h-100">
    <b-container fluid>
      <h2 class="tw-mb-0 text-aegis-dk">
        Review Action Taken
      </h2>
      <p class="tw-italic tw-text-gray-700">
        Review Action Taken
      </p>
    </b-container>

    <b-container fluid class="tw-my-5">
      <b-row>
        <b-col lg="4"></b-col>
        <b-col lg="4"></b-col>
        <b-col lg="4">
          <b-form-group
          label=""
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          label-for="filterInput"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              v-model="filter"
              type="search"
              id="filterInput"
              placeholder="Type to Search"
            ></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        </b-col>
      </b-row>
    </b-container>
    <hr>

     <b-card no-body v-if="inMyGroups(['Subject Final Status Workflow Editor', 'Site PI'])">
        <b-tabs card fill>
          <b-tab :title="'New ('+new_alerts_count+')'" active v-if="inMyGroups(['Subject Final Status Workflow Editor', 'Site PI'])">
            <b-card-text >
              <b-table striped hover :fields="new_alerts_fields" :items="new_alerts_items" :filter="filter">
                <template v-slot:cell(name)="data">
                    <b-link :href="data.item.case_link" target="_blank">{{ data.item.name }}</b-link>
                </template>

                <template v-slot:cell(dismiss)="data">
                  <div v-if="show_buttons">
                    <b-button
                      @click="dismiss(data.index)"
                      size="sm"
                      variant="success"
                      class="w-20"
                    >
                      Dismiss
                    </b-button>
                  </div>
                  <div else>
                    <!-- <b-alert v-if="show_loading" variant="info" show>Processing... <i class="fas fa-spin fa-spinner"></i></b-alert> -->
                    <div v-if="show_loading">Processing... <i class="fas fa-spin fa-spinner"></i></div>
                  </div>
                </template>

              </b-table>
            </b-card-text>
          </b-tab>

          <b-tab :title="'Dismissed ('+dismissed_alerts_count+')'" v-if="inMyGroups(['Subject Final Status Workflow Editor', 'Site PI'])">
            <b-card-text >

              <b-table striped hover :fields="dismissed_alerts_fields" :items="dismissed_alerts_items" :filter="filter">
                <template v-slot:cell(dismiss)="data">
                  <!-- dismissed timestamp -->
                  {{data.item.created}}
                </template>
              </b-table>
            </b-card-text>
          </b-tab>
        </b-tabs>
     </b-card>
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

import { mapState, mapGetters } from "vuex";

export default {
  mixins: [DashboardBaseTemplate],
  data: function() {
    return {
      new_alerts_fields: [
        { key: "products_last_placed_on", label: "Date of Submission"},
        { key: "household_id", label: "HHID" },
        { key: "head_of_household", label: "Head of HH Name" },
        { key: "head_telephone_number", label: "Head of HH Phone"},
        { key: "notes", label: "Notes"},
        { key: "dismiss", label: "Dismiss"},
      ],

      dismissed_alerts_fields: [
        { key: "products_last_placed_on", label: "Date of Submission"},
        { key: "household_id", label: "HHID" },
        { key: "head_of_household", label: "Head of HH Name" },
        { key: "head_telephone_number", label: "Head of HH Phone"},
        { key: "notes", label: "Notes"},
        { key: "dismiss", label: "Dismiss"},
      ],
      new_alerts_items: [],
      dismissed_alerts_items: [],
      componentKey: 0,
      filter: null,
      show_buttons: true,
      show_loading: false,
      new_alerts_count: 0,
      dismissed_alerts_count: 0,
    };
  },
  computed: {
    ...mapState("user", ["user", "myGroups"]),
    ...mapGetters('user', ['inMyGroups'])
  },
  mounted: function() {
    this.new_request();
    this.dismissed_request();
  },
  methods: {
    new_request: function() {
      let that = this;
      HTTP.get("/uganda/review-action-taken/get_new").then(response => {
        that.new_alerts_items = response.data;
        that.new_alerts_count = that.new_alerts_items.length;
      }).catch((error) => {
        HandleErrors.HandleErrors(error);
      }).then(() => {
        that.show_loading = false;
        that.show_buttons = true;
      });
    },
    dismissed_request: function() {
      let that = this;
      HTTP.get("/uganda/review-action-taken/get_dismissed").then(response => {
        that.dismissed_alerts_items = response.data;
        that.dismissed_alerts_count = that.dismissed_alerts_items.length;
      });
    },
    dismiss: function(index){
      let that = this;
      that.show_buttons = false;
      that.show_loading = true;
      // case_id instead of id
      HTTP.post("/uganda/review-action-taken/"+that.new_alerts_items[index].case_id+"/", {
        status: 'approve',
        // pass notes as well
        notes: that.new_alerts_items[index].notes
      }).then(response => {
          that.new_request();
          that.dismissed_request();
      });
    },
  }
};
</script>

<style>
</style>